import { Form } from '~/shared/api'
import { emptyRule } from '~/shared/utils/validation'

export default class AccountVacancyAboutCompanyForm extends Form {
  'company_description': string = ''

  toInputData() {
    return {
      company_description: this.company_description
    }
  }

  static rules() {
    return {
      company_description: emptyRule
    }
  }
}
